var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51744 7.49996L9.69465 9.78103C9.8781 9.91274 10.1211 9.91274 10.3045 9.78103L13.4817 7.49996M6.7853 13.3333H13.2139C13.8056 13.3333 14.2853 12.8358 14.2853 12.2222V7.77774C14.2853 7.16409 13.8056 6.66663 13.2139 6.66663H6.7853C6.19356 6.66663 5.71387 7.16409 5.71387 7.77774V12.2222C5.71387 12.8358 6.19356 13.3333 6.7853 13.3333Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionEmail);
export default __webpack_public_path__ + "static/media/question-email.a9c6a78a6d6464ee01d6ad95ce275ddd.svg";
export { ForwardRef as ReactComponent };